module.exports = __webpack_public_path__ + "img/pedro-plasencia.jpg";